import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, serverApi } from "../configuration/authConfig";
import EnvVars from "./variables";

const msalInstance: PublicClientApplication = new PublicClientApplication(msalConfig);

export const getMSALInstance = (): PublicClientApplication => {
  return msalInstance;
};

export const isAzureMode = (): boolean => !EnvVars.LOCAL_MODE || EnvVars.LOCAL_MODE  === "0";

export const refreshToken = async (): Promise<string> => {

  if (!isAzureMode()) {
    return Promise.resolve(localStorage.getItem("token") ?? "");
  }

  const accounts = msalInstance?.getAllAccounts();
  if (!accounts?.length) {
    throw new ReferenceError();
  }

  try {
    const response = await msalInstance?.acquireTokenSilent({
      scopes: serverApi.scopes,
      account: accounts[0]
    });

    if (response?.accessToken) {
      return response?.accessToken;
    }
  } catch (e: any) {
    console.error(e.message);
  }

  throw new ReferenceError();
};
